import { render, staticRenderFns } from "./LoginTenantSelector.vue?vue&type=template&id=2d1be7be&scoped=true"
import script from "./LoginTenantSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginTenantSelector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LoginTenantSelector.vue?vue&type=style&index=0&id=2d1be7be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1be7be",
  null
  
)

export default component.exports